// extracted by mini-css-extract-plugin
export default {"innerWrapper":"LB-z","tooltipWrapper":"MB-z","icon":"NB-z","tooltip":"OB-z","content":"PB-z"};